var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('d-button-group',{staticClass:"buttons"},[_c('d-button',{staticClass:"btn-danger",attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.confirmDeleteRow()}}},[_c('i',{staticClass:"fas fa-trash"}),_c('span',{staticClass:"d-none d-lg-inline"},[_vm._v(" Deletar")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }